import AbstractVertical from './AbstractVertical'

export default class Airport extends AbstractVertical {

  readonly name: string = 'airport'
  readonly title: string = 'Airport'
  readonly color: string = '#348037'
  readonly sortWeight: number = 0

  readonly supportedFeatures: string[] = [
    'showOnRateManagementCalendar',
    'spotRates',
    'editInventory',
    'showOnUniversalInventoryCalendar',
  ]

}
